/**
 * Log levels for the auth-only utilities
 */
type LogLevel = 'log' | 'warn' | 'error'

/**
 * Internal logger function that handles different log levels with consistent formatting
 */
const createLogger = (level: LogLevel) => {
	return (message: string, error?: Error): void => {
		const formattedMessage = `[auth-only] ${message}`

		if (error) {
			console[level](formattedMessage, error)
		} else {
			console[level](formattedMessage)
		}
	}
}

/**
 * Logs an informational message with the auth-only prefix
 * @param message - The message to log
 */
export const log = createLogger('log')

/**
 * Logs an error message with the auth-only prefix
 * @param message - The error message to log
 * @param error - Optional error object to include
 */
export const error = createLogger('error')

/**
 * Logs a warning message with the auth-only prefix
 * @param message - The warning message to log
 * @param error - Optional error object to include
 */
export const warn = createLogger('warn')
